import React from "react";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionHeading } from "@/components/sections/SectionHeading";
import { STEPS } from "@/data/content";

export const HowItWorks = () => {
  return (
    <section id="how-it-works" data-testid="how-it-works" className="relative bg-ivory-light py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          align="center"
          overline="How it works"
          title="Three taps to golden wealth"
          accentWord="golden wealth"
          subtitle="Fund, convert and vault — the whole journey from cash to insured 24K gold takes under a minute."
        />

        <div className="relative mt-20">
          {/* connecting glowing line */}
          <div className="pointer-events-none absolute left-0 right-0 top-10 hidden h-px md:block">
            <div className="mx-auto h-px max-w-4xl bg-gradient-to-r from-transparent via-gold/50 to-transparent" />
          </div>

          <StaggerGroup className="grid gap-10 md:grid-cols-3" stagger={0.14}>
            {STEPS.map((s) => (
              <StaggerItem key={s.step}>
                <div className="relative flex flex-col items-center text-center">
                  <div className="relative mb-6 flex h-20 w-20 items-center justify-center rounded-full border border-amber-200/60 bg-ivory-light shadow-[0_8px_28px_-8px_rgba(212,175,55,0.4)]">
                    <span className="absolute inset-0 rounded-full bg-gold/10 animate-pulse-ring" />
                    <s.icon className="h-8 w-8 text-gold" strokeWidth={1.7} />
                  </div>
                  <span className="font-serif text-sm font-medium tracking-[0.2em] text-gold">{s.step}</span>
                  <h3 className="mt-2 font-serif text-2xl font-normal text-charcoal">{s.title}</h3>
                  <p className="mt-3 max-w-xs leading-relaxed text-charcoal-soft">{s.body}</p>
                </div>
              </StaggerItem>
            ))}
          </StaggerGroup>
        </div>
      </div>
    </section>
  );
};
